import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthProvider } from '../auth-process.service';
import { ICredentials } from '../auth-interfaces';

export interface ILegalityDialogParams {
  tosUrl: string;
  privacyPolicyUrl: string;
  authProvider: AuthProvider;
  credentials?: ICredentials;
}

export interface ILegalityDialogResult {
  checked: boolean;
  authProvider: AuthProvider;
  credentials?: ICredentials;
}

@Component({
  selector: 'pt-auth-firebaseui-legality-dialog',
  templateUrl: './legality-dialog.component.html',
  styleUrls: ['./legality-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LegalityDialogComponent {
  private _disableConfirmActionButton = false;
  checkTOS: boolean;
  checkPrivacyPolicy: boolean;

  constructor(
    public dialogRef: MatDialogRef<LegalityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ILegalityDialogParams
  ) {}

  get disableConfirmActionButton(): boolean {
    if (this.data.tosUrl && this.data.privacyPolicyUrl) {
      this._disableConfirmActionButton = !(
        this.checkTOS && this.checkPrivacyPolicy
      );
    } else if (this.data.tosUrl && !this.data.privacyPolicyUrl) {
      this._disableConfirmActionButton = !this.checkTOS;
    } else if (!this.data.tosUrl && this.data.privacyPolicyUrl) {
      this._disableConfirmActionButton = !this.checkPrivacyPolicy;
    }
    return this._disableConfirmActionButton;
  }

  closeDialog(): void {
    const result: ILegalityDialogResult = {
      checked: !this.disableConfirmActionButton,
      authProvider: this.data.authProvider,
    };
    this.dialogRef.close(result);
  }
}
